import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { CaretUpIcon, CaretDownIcon } from '@glu/icons-react';
import { withStyles } from 'theme/withStyles';
import Button from 'common/Button';
import RawHtml from 'common/RawHtml';

const styles = ({ oaoButtons: buttons, palette, screenSizes, shadows }) => ({
  active: {},
  applyOtherMenu: {
    '&$active': {
      display: 'block',
    },
    background: palette.primary,
    boxShadow: shadows.tooltip,
    display: 'none',
    listStyle: 'none',
    margin: [3, 0, 0, 0],
    padding: [10, 0],
    position: 'absolute',
    right: 0,
    top: '100%',
    width: 300,
    zIndex: 10,
    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      margin: [0, 50],
      width: 'calc(100% - 100px)',
    },
  },
  applyOtherNav: {
    marginTop: 12,
    position: 'absolute',
    right: 0,
    textAlign: 'right',
    top: 0,
    width: '100%',
    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      position: 'relative',
      textAlign: 'center',
      width: '100%',
    },
  },
  handle: {
    fontSize: 20,
    paddingRight: 75,
  },
  iconCaret: {
    '& svg': {
      fill: buttons.primary.color,
    },
    position: 'absolute',
    right: 10,
    top: 15,
  },
  productLink: {
    '&:hover': {
      background: '#ededed',
    },
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    float: 'left',
    padding: [3, 15],
    textAlign: 'left',
    width: '100%',
  },
  showcase: {
    '& $iconCaret': {
      display: 'none',
    },
    paddingRight: 24,
  },
});

export const HomeApplyOtherMenu = ({ classes }) => {
  const [applyOtherMenu, setApplyOtherMenu] = useState(false);
  const enableShowcase = useSelector((state) => state.configs.showcase);
  const marketIdentifier = useSelector((state) => state.session.meta?.configs?.marketIdentifier);
  const market = useSelector((state) => state.refs.market);
  const products = useSelector((state) => state.data.products);
  const applyLinkLabel = useSelector((state) => state.resources.applyLinkLabel);

  return (
    <nav className={classnames('apply-other-nav', classes.applyOtherNav)}>
      <Button
        type="button"
        className={classnames('apply-other btn btn-mobile btn-primary,', classes.handle, {
          [classes.showcase]: enableShowcase,
          showcase: enableShowcase,
        })}
        onClick={(e) => {
          e.preventDefault();
          if (enableShowcase) {
            window.location.href = '../branch/online';
          } else {
            setApplyOtherMenu(!applyOtherMenu);
          }
        }}
      >
        <RawHtml type="span">{applyLinkLabel}</RawHtml>{' '}
        {applyOtherMenu ? (
          <CaretUpIcon className={classnames('icon-caret-up', classes.iconCaret)} />
        ) : (
          <CaretDownIcon className={classnames('icon-caret-down', classes.iconCaret)} />
        )}
      </Button>
      <ul
        className={classnames('apply-other-menu', classes.applyOtherMenu, {
          active: applyOtherMenu,
          [classes.active]: applyOtherMenu,
        })}
      >
        {products?.map((product) => (
          <li key={product.name} data-name={product.name}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <button
              className={classnames('buttonLink', classes.productLink)}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setApplyOtherMenu(!applyOtherMenu);

                const url = new URL(`${window.location.origin}/oao`);
                if (product) url.searchParams.append('product', product.name);
                if (market) url.searchParams.append(marketIdentifier, market);
                window.location.assign(url.href);
              }}
            >
              <RawHtml type="span">{product.label}</RawHtml>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

HomeApplyOtherMenu.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

const HomeApplyOtherMenuStyled = withStyles(styles)(HomeApplyOtherMenu);

export default HomeApplyOtherMenuStyled;
